// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/anchor.js'; import './autoload/blog.js'; import './autoload/case-studies-archive.js'; import './autoload/case-studies.js'; import './autoload/case-study-single.js'; import './autoload/case-study-video.js'; import './autoload/certifications.js'; import './autoload/clients-logos.js'; import './autoload/clients-slider.js'; import './autoload/expertise.js'; import './autoload/faq.js'; import './autoload/home-hero.js'; import './autoload/key-figures-gallery.js'; import './autoload/lazyload.js'; import './autoload/marquee.js'; import './autoload/menu.js'; import './autoload/reveal.js'; import './autoload/stat-counter.js'; import './autoload/team-grid.js'; import './autoload/team-videos.js'; import './autoload/tech-suite.js'; // eslint-disable-line

// Import local dependencies
import { scrollIntoViewWithOffset } from './utils/helpers';

// Import plugins
import 'jquery-match-height';

import ScrollOut from 'scroll-out';

/**
 * Set CSS variable for header height
 */
const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

/**
 * Scripts which runs after DOM load
 */

$(document).ready(function () {
  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    once: true,
    threshold: 0.4,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (_, formId) {
    let target = document.getElementById(
      `gform_confirmation_wrapper_${formId}`
    );

    if (target) {
      scrollIntoViewWithOffset(target, 100);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // Preloader
  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
